import { collection, doc, DocumentReference } from 'firebase/firestore';
import { db } from '../../firebase';
import type { ModifiableData } from './EpisodeContent/types';
import { DraftRecordingSession, TakeGroup } from './types';

export const recordingSessionRef = (sessionId: string) => doc(db, 'recording-session', sessionId);
export const episodeDataCollectionRef = (sessionId: string) => collection(recordingSessionRef(sessionId), 'episode-data');
export const episodeDataCollectionByDocRef = (docRef: DocumentReference<DraftRecordingSession>) => collection(docRef, 'episode-data');
export const episodeDataRef = (sessionId: string, episodeId: string) => doc(recordingSessionRef(sessionId), 'episode-data', episodeId);
// eslint-disable-next-line max-len
export const episodeDataRefByDocRef = (docRef: DocumentReference<DraftRecordingSession>, episodeId: string) => doc(docRef, 'episode-data', episodeId);
export const episodeCompsRef = (sessionId: string, episodeId: string) => collection(episodeDataRef(sessionId, episodeId), 'comps');
export const episodeCompByIdRef = (sessionId: string, episodeId: string, compId: string) =>
    doc(episodeCompsRef(sessionId, episodeId), compId);
export const episodeTakeGroupsRef = (sessionId: string, episodeId: string) =>
    collection(episodeDataRef(sessionId, episodeId), 'take-groups');
export const episodeSelectInfosRef = (sessionId: string, episodeId: string) =>
    collection(episodeDataRef(sessionId, episodeId), 'select-info');
export const episodeSelectInfoRef = (sessionId: string, episodeId: string, revisionChainId: string) =>
    doc(episodeDataRef(sessionId, episodeId), 'select-info', revisionChainId);

export const sortModifiableData = (
    data: ModifiableData[],
    recordingOrder: 'ByCharacter' | 'Chronologically',
    characterIdOrder: string[]
) => {
    if (recordingOrder === 'ByCharacter') {
        return data.toSorted((a, b) => {
            if (a.characterId === b.characterId) {
                return a.ordinal - b.ordinal;
            }
            return characterIdOrder.indexOf(a.characterId) - characterIdOrder.indexOf(b.characterId);
        });
    } else if (recordingOrder === 'Chronologically') {
        return data.toSorted((a, b) => a.ordinal - b.ordinal);
    }
    return data;
}

export const getNextTakeNumberString = (takeGroups: TakeGroup[]) => {
    return (1 + takeGroups.reduce((acc, cur) => {
        const parsed = parseInt(cur.take, 10);
        if (!isNaN(parsed))
            return Math.max(acc, parsed);
        return acc;
    }, 0)).toString();
}

export const formatCompText = (str: string) => str.replace(/\s+/g, ' ');

// Comp colors
const colors = [
    '#FDDC98',
    '#CFE79A',
    '#ABE7EC',
    '#B8DCFF',
    '#DDD2FF',
    '#E7AAC3',
    '#FCC825',
    '#99C22B',
    '#6DCDD5',
    '#86C5FF',
    '#B867CD',
    '#DE8EBD',
];

type ObjectWithTakes = {
    takes: {
        takeId: string
    }[]
}

export const getColorMap = (comp?: ObjectWithTakes) => comp?.takes.reduce((acc, take) => {
    acc[take.takeId] = colors[Object.keys(acc).length % colors.length];
    return acc;
}, {} as Record<string, string>);